export default `
  @theme {
    --font-*: initial;
    --font-sans: 'Inter', sans-serif;

    --text-*: initial;
    --text-sm: 9px;
    --text-sm--line-height: 0.5rem;
    --text-sm--letter-spacing: 0.5px;
    --text-sm--font-weight: 700;
    --text-sm--text-transform: uppercase;
    --text-base: 0.75rem;
    --text-base--line-height: 1rem;
    --text-base--letter-spacing: 0;
    --text-base--font-weight: 500;
    --text-lg: 1rem;
    --text-lg--line-height: 1.5rem;
    --text-lg--letter-spacing: 0;
    --text-lg--font-weight: 500;
    --text-xl: 1.25rem;
    --text-xl--line-height: 1.5rem;
    --text-xl--letter-spacing: 0;
    --text-xl--font-weight: 500;
    --radius-sm: 0.125rem;

    --custom-gray-100: #f9f9fa;
    --custom-gray-200: #f0f2f4;
    --custom-gray-300: #e1e6e9;
    --custom-gray-400: #d3d9de;
    --custom-gray-500: #b5c0c8;
    --custom-gray-600: #899ba8;
    --custom-gray-700: #7b8f9d;
    --custom-gray-800: #627684;
    --custom-gray-900: #576975;
    --custom-gray-1000: #3d4f5c;
    --custom-gray-1100: #263540;
    --custom-gray-1200: #1d2830;
    --custom-gray-1300: #131b20;
    --custom-gray-1400: #0f151a;
    --custom-gray-1500: #0a0d10;
    --custom-gray-1600: #06080a;

    --custom-blue-100: #e2eff9;
    --custom-blue-200: #a8d2f0;
    --custom-blue-300: #79bcec;
    --custom-blue-400: #338ccc;
    --custom-blue-500: #1f72ad;
    --custom-blue-600: #085891;
    --custom-blue-700: #00264c;

    --custom-green-100: #d2f8df;
    --custom-green-200: #9ae6b4;
    --custom-green-300: #47b96d;
    --custom-green-400: #0da54c;
    --custom-green-500: #0b8e37;
    --custom-green-600: #0a7625;

    --custom-yellow-100: #fff2cc;
    --custom-yellow-200: #ffe97f;
    --custom-yellow-300: #ffd24c;
    --custom-yellow-400: #feb219;
    --custom-yellow-500: #ff9400;
    --custom-yellow-600: #ef7700;
    --custom-yellow-700: #cc4300;

    --custom-red-100: #ffe5e9;
    --custom-red-200: #fe8ea1;
    --custom-red-300: #ff4d6b;
    --custom-red-400: #f42548;
    --custom-red-500: #e0062a;
    --custom-red-600: #b7001d;
    --custom-red-700: #7f0014;
  }

  @utility twy-text-accent {
    @apply text-(--custom-blue-500) dark:text-(--custom-blue-300);
  }

  @utility twy-text-accent-hover {
    @apply hover:text-(--custom-blue-600) dark:hover:text-(--custom-blue-400);
  }

  @utility twy-text-success {
    @apply text-(--custom-green-500) dark:text-(--custom-green-300);
  }

  @utility twy-text-success-hover {
    @apply hover:text-(--custom-green-600) dark:hover:text-(--custom-green-400);
  }

  @utility twy-text-warning {
    @apply text-(--custom-(--custom-yellow-500)) dark:text-(--custom-(--custom-yellow-300));
  }

  @utility twy-text-warning-hover {
    @apply hover:text-(--custom-(--custom-yellow-600)) dark:hover:text-(--custom-(--custom-yellow-400));
  }

  @utility twy-text-danger {
    @apply text-(--custom-red-500) dark:text-(--custom-red-300);
  }

  @utility twy-text-danger-hover {
    @apply hover:text-(--custom-red-600) dark:hover:text-(--custom-red-400);
  }

  @utility twy-text-neutral {
    @apply text-(--custom-gray-800) dark:text-(--custom-gray-400);
  }

  @utility twy-text-neutral-hover {
    @apply hover:text-(--custom-gray-900) dark:hover:text-(--custom-gray-500);
  }

  @utility twy-text-base {
    @apply text-(--custom-gray-800) dark:text-(--custom-gray-600);
  }

  @utility twy-text-base-accent {
    @apply text-(--custom-gray-1200) dark:text-(--custom-gray-200);
  }

  @utility twy-text-base-neutral {
    @apply text-(--custom-gray-600) dark:text-(--custom-gray-1000);
  }

  @utility twy-bg-accent {
    @apply bg-(--custom-blue-400) dark:bg-(--custom-blue-500);
  }

  @utility twy-bg-accent-hover {
    @apply hover:bg-(--custom-blue-500) dark:hover:bg-(--custom-blue-600);
  }

  @utility twy-bg-success {
    @apply bg-(--custom-green-400) dark:bg-(--custom-green-500);
  }

  @utility twy-bg-success-hover {
    @apply hover:bg-(--custom-green-500) dark:hover:bg-(--custom-green-600);
  }

  @utility twy-bg-warning {
    @apply bg-(--custom-yellow-400) dark:bg-(--custom-yellow-500);
  }

  @utility twy-bg-warning-hover {
    @apply hover:bg-(--custom-yellow-500) dark:hover:bg-(--custom-yellow-600);
  }

  @utility twy-bg-danger {
    @apply bg-(--custom-red-400) dark:bg-(--custom-red-500);
  }

  @utility twy-bg-danger-hover {
    @apply hover:bg-(--custom-red-500) dark:hover:bg-(--custom-red-600);
  }

  @utility twy-bg-neutral {
    @apply bg-(--custom-gray-600) dark:bg-(--custom-gray-800);
  }

  @utility twy-bg-neutral-hover {
    @apply hover:bg-(--custom-gray-800) dark:hover:bg-(--custom-gray-1000);
  }

  @utility twy-bg-base {
    @apply bg-(--custom-gray-100) dark:bg-(--custom-gray-1500);
  }

  @utility twy-bg-base-accent {
    @apply bg-white dark:bg-(--custom-gray-1400);
  }

  @utility twy-bg-base-neutral {
    @apply bg-(--custom-gray-100) dark:bg-(--custom-gray-1300);
  }

  @utility twy-border-accent {
    @apply border-(--custom-blue-400)/20 dark:border-(--custom-blue-400)/20;
  }

  @utility twy-border-accent-hover {
    @apply hover:border-(--custom-blue-500)/20 dark:hover:border-(--custom-blue-500)/20;
  }

  @utility twy-border-success {
    @apply border-(--custom-green-400)/20 dark:border-(--custom-green-400)/20;
  }

  @utility twy-border-success-hover {
    @apply hover:border-(--custom-green-500)/20 dark:hover:border-(--custom-green-500)/20;
  }

  @utility twy-border-warning {
    @apply border-(--custom-yellow-400)/20 dark:border-(--custom-yellow-400)/20;
  }

  @utility twy-border-warning-hover {
    @apply hover:border-(--custom-yellow-500)/20 dark:hover:border-(--custom-yellow-500)/20;
  }

  @utility twy-border-danger {
    @apply border-(--custom-red-400)/20 dark:border-(--custom-red-400)/20;
  }

  @utility twy-border-danger-hover {
    @apply hover:border-(--custom-red-500)/20 dark:hover:border-(--custom-red-500)/20;
  }

  @utility twy-border-neutral {
    @apply border-(--custom-gray-600)/20 dark:border-(--custom-gray-600)/20;
  }

  @utility twy-border-neutral-hover {
    @apply hover:border-(--custom-gray-700)/20 dark:hover:border-(--custom-gray-700)/20;
  }

  @utility twy-border-base {
    @apply border-(--custom-gray-300) dark:border-(--custom-gray-1200);
  }

  @utility twy-border-base-accent {
    @apply border-(--custom-gray-400) dark:border-(--custom-gray-1100);
  }

  @utility twy-subtle-accent {
    @apply bg-(--custom-blue-400)/10 dark:bg-(--custom-blue-400)/10;
  }

  @utility twy-subtle-accent-hover {
    @apply hover:bg-(--custom-blue-400)/20 dark:hover:bg-(--custom-blue-400)/20;
  }

  @utility twy-subtle-success {
    @apply bg-(--custom-green-400)/10 dark:bg-(--custom-green-400)/10;
  }

  @utility twy-subtle-success-hover {
    @apply hover:bg-(--custom-green-400)/20 dark:hover:bg-(--custom-green-400)/20;
  }

  @utility twy-subtle-warning {
    @apply bg-(--custom-yellow-400)/10 dark:bg-(--custom-yellow-400)/10;
  }

  @utility twy-subtle-warning-hover {
    @apply hover:bg-(--custom-yellow-400)/20 dark:hover:bg-(--custom-yellow-400)/20;
  }

  @utility twy-subtle-danger {
    @apply bg-(--custom-red-400)/10 dark:bg-(--custom-red-400)/10;
  }

  @utility twy-subtle-danger-hover {
    @apply hover:bg-(--custom-red-400)/20 dark:hover:bg-(--custom-red-400)/20;
  }

  @utility twy-subtle-neutral {
    @apply bg-(--custom-gray-600)/10 dark:bg-(--custom-gray-600)/10;
  }

  @utility twy-subtle-neutral-hover {
    @apply hover:bg-(--custom-gray-600)/20 dark:hover:bg-(--custom-gray-600)/20;
  }

  @layer base {
    body {
      @apply text-base twy-text-base;
    }
  }
`

const customGrays = {
  100: '#f9f9fa',
  200: '#f0f2f4',
  300: '#e1e6e9',
  400: '#d3d9de',
  500: '#b5c0c8',
  600: '#899ba8',
  700: '#7b8f9d',
  800: '#627684',
  900: '#576975',
  1000: '#3d4f5c',
  1100: '#263540',
  1200: '#1d2830',
  1300: '#131b20',
  1400: '#0f151a',
  1500: '#0a0d10',
  1600: '#06080a',
}

export const customColors = {
  twyTextBase: `text-[${customGrays[800]}] dark:text-[${customGrays[600]}]`,
  twyTextBaseAccent: `text-[${customGrays[1200]}] dark:text-[${customGrays[200]}]`,
  twyTextBaseAccentHover: `hover:text-[${customGrays[1300]}] dark:hover:text-[${customGrays[300]}]`,
  twyBgBaseAccent: `bg-white dark:bg-[${customGrays[1400]}]`,
  twyBgBase: `bg-[${customGrays[100]}] dark:bg-[${customGrays[1500]}]`,
  twyBgBaseHover: `hover:bg-[${customGrays[100]}] dark:hover:bg-[${customGrays[1500]}]`,
  twyBorderBase: `border-[${customGrays[300]}] dark:border-[${customGrays[1200]}]`,
}
